import EditPromotion from 'pages/BackOfficePage/BackOfficeCategories/Promotion/EditPromotion/EditPromotion';

export default EditPromotion;
